export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Erreur d'initialisation",
    "StaticConfigLoader.caption.init": "Initialisation",
    "StaticConfigLoader.text.init": "Initialisation de l'application...",
    "StaticConfigLoader.error.settings": "Chargement impossible des paramètres du site",
    "StaticConfigLoader.error.circuits": "Chargement impossible de la configuration des services",
    //app
    "Legal.Localization": "fr",
    "AchievementApp.Navbar.storeTitle": "Magasin",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Termes et conditions",
    "Legal.TermsService": "Conditions du service",
    "Legal.PrivacyPolicy": "Politique de confidentialité",
    "Legal.CookiesPolicy": "Paramètres relatifs aux cookies",
    "Legal.Copyright": "Les marques de commerce, logos et noms de marques sont la propriété de leurs détenteurs respectifs.",
    "AchievementApp.Navbar.achievement": "Succès personnel",
    "AchievementApp.Navbar.userAchievement": "Succès de l'utilisateur",
    "AchievementApp.Navbar.settingsLink": "Paramètres",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Se reconnecter ou changer de compte",
    "AchievementApp.Navbar.pageTitlePrew": "Succès ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Terminé",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtrer par titres",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Mes amis",
    "UserFriendsList.heading.showMore": "Afficher plus",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Veuillez configurer l'autorisation en deux étapes",
    "LimitedAccountPanel.2step.link": "En savoir plus sur l'autorisation en deux étapes",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Veuillez confirmer votre adresse e-mail",
    "LimitedAccountPanel.email.link": "Accéder au profil",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Votre compte est limité en raison de :",
    "LimitedAccountPanel.conclusion": "Une fois les paramètres changés, déconnectez-vous puis connectez-vous à nouveau pour les appliquer",
    "LimitedAccountPanel.relogin": "Se reconnecter",
    "EmailVerificationStateIcon.success": "Compte confirmé, e-mail vérifié",
    "EmailVerificationStateIcon.warning": "Compte non confirmé, e-mail non vérifié",
    "EmailVerificationStateIcon.danger": "Compte non confirmé, vérification d'e-mail REQUISE",
    "TwoFactorStateIcon.success": "Compte sécurisé par une autorisation en deux étapes",
    "TwoFactorStateIcon.warning": "Compte non sécurisé, autorisation en deux étapes désactivée",
    "TwoFactorStateIcon.danger": "Autorisation en deux étapes REQUISE",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Sauvegarder les paramètres",
    "UserSettingDialog.settings": "Paramètres",
    "UserSettingDialog.userSettings": "Paramètres utilisateur",
    "UserSettingDialog.language": "Langue",
    "UserSettingDialog.privacy": "Filtrage des messages privés",
    "UserSettingDialog.allUsers": "Tous les utilisateurs",
    "UserSettingDialog.friendsOnly": "Amis uniquement",
    "UserSettingDialog.onlyMe": "Moi uniquement",
    "UserSettingDialog.whoCanView": "Qui peut consulter mes succès",
    //unlockProgress
    "ViewUnlockProgress.of": " de ",
    "ViewUnlockProgress.achievCompleted": " succès terminés",
    "ViewUnlockProgress.myUnlock": "Mes succès",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Rechercher pseudo",
    "ViewItemSearch.label.search": "Rechercher utilisateurs",
    "ViewItemSearch.resultNotFound": "Utilisateur introuvable",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Succès",
    "ViewItemSearch.stub.empty": "Aucun succès",
    "ViewItemSearch.stub.emptyCompare_1": "Utilisateur ",
    "ViewItemSearch.stub.emptyCompare_2": " n'a aucun succès dans ce jeu",
    "ViewItemSearch.limitedAccess": "L'accès aux succès de cet utilisateur est limitéac",
    "ViewItemSearch.heading.selectGame": "Sélectionner un jeu dans la liste",
    "ViewItemSearch.globalstat.opened": "débloqué par ",
    "ViewItemSearch.globalstat.ofGamers": "% des joueurs",
    //authentication
    "NotAllowedMessage.caption": "Interdit",
    "NotAllowedMessage.body.h1": "Accès aux succès",
    "NotAllowedMessage.body.h3": "actuellement interdit pour votre compte",
    "NotAllowedMessage.relogin": "Changer de compte",
    "LandingMessage.caption": "Authentification",
    "LandingMessage.body": "Fin de l'atterrissage...",
    "TokenExpiredMessage.caption": "L'authentification a expiré",
    "TokenExpiredMessage.body.h3": "Il n'y a pas grand-chose à faire, mais vous pouvez quand même",
    "TokenExpiredMessage.relogin": "Se reconnecter",
    "AuthErrorMessage.caption": "L'authentification a échoué",
    "AuthErrorMessage.body.h1": "L'authentification n'a pu être vérifiée",
    "AuthErrorMessage.body.code": "Code",
    "AuthErrorMessage.body.desc": "Il n'y a pas grand-chose à faire, mais vous pouvez quand même",
    "AuthErrorMessage.relogin": "Se reconnecter",
    "AuthorizationRequiredMessage.caption": "Authentification requise",
    "AuthorizationRequiredMessage.body.h3.1": "Vous allez accéder",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Il vous faut une autorisation pour continuer",
    "AuthorizationRequiredMessage.login": "Se connecter avec Gaijin.Net",
    "CheckingAuthMessage.caption": "Authentification",
    "CheckingAuthMessage.body": "Vérification de l'authentification, un instant",
    "AuthorizationRequiredMessageMobile.body.h3.1": "La version mobile est temporairement indisponible",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Veuillez utiliser la version ordinateur",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Veuillez nous excuser",
}